export const FILTER_TABS = [
  { id: 'all', label: 'All' },
  { id: 'unread', label: 'Unread' },
  { id: 'Sessions', label: 'Sessions' },
  { id: 'Messages', label: 'Messages' },
  { id: 'Support', label: 'Support' },
];

export const FILTER_OPTIONS = [
  { id: 'all', label: 'All notifications' },
  { id: 'unread', label: 'Unread only' },
  { id: 'Sessions', label: 'Sessions' },
  { id: 'Messages', label: 'Messages' },
  { id: 'Support', label: 'Support' },
];

export const FOOTER_NOTE =
  'System messages from Tutor Scene cannot be deleted. Unread notifications are marked with a red dot. Use the trash icon to delete a notification.';

export const formatDetailDate = (dateString) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  const datePart = d.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
  const timePart = d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
  return `${datePart} • ${timePart}`;
};
